import { useEffect, useState } from "react";
import { Main, Content } from "../../../components/Layout";
import api from "../../../services/api";
import { ChartsBar } from "../../../components/Charts";
import { Col, Row } from "react-bootstrap";
import DatePicker from "../../../components/DatePicker";
import Slct from "../../../components/Slct";
import getCommercial from "../../../util/getCommercial";
import { IntegerNumber } from "../../../components/Input";
import IcX from "../../../components/Svg/IcX";
import { ModalAddTask } from "../../../components/Modal";
import Loading from "../../../components/Loading";
import { formatDate } from "../../../util/functions";
import { PrintPage } from "../../../components/PrintPage";
import useWrapper from "../../../hooks/useWrapper";
import TableResponsive from "../../../components/TableResponsive";
import StatusFlag from "../../../components/StatusFlag";
import { NavLink } from "react-router-dom";
import useFormat from "../../../hooks/utils/useFormat";
import colorFromIndex from "../../../hooks/utils/colorFromIndex";

export default function ReportsEvents() {
  const { setbreadcrumb, config, me } = useWrapper();
  const { stringToDate } = useFormat();

  const [pageloaded, setpageloaded] = useState(false);
  const [reload, setreload] = useState();
  const [groups, setgroups] = useState([]);
  const [events, setevents] = useState();
  useEffect(() => {
    setpageloaded(false);
    // api.get("events?paginate=false&eventDates.due_date=2022-07-13|2022-07-16", config)
    api
      .get("events?paginate=false", config)
      .then(resp => {
        let _all_events = [];

        resp.data.forEach(e => {
          e.eventDates.forEach(e2 => {
            _all_events.push({
              id: e2.id,
              event_id: e.id,
              category_id: e.category_id,
              name: e.name,
              commercial: {
                id: e2.commercials.id,
                name: `${e2.commercials.course.title} ${e2.commercials.institution.title} ${e2.commercials.year}.${
                  e2.commercials.period
                }${e2.commercials.contract_number_legacy ? ` - ${e2.commercials.contract_number_legacy}` : ""}`,
                institution_name: e2.commercials.institution.title,
                year: e2.commercials.year,
                period: e2.commercials.period,
              },
              due_date: e2.due_date,
              status: !!e2.due_date
                ? stringToDate(e2.due_date) >= new Date()
                  ? "A Acontecer"
                  : "Finalizadas"
                : "A Definir",
            });
          });
        });

        _all_events.sort((a, b) => {
          return stringToDate(a.due_date) - stringToDate(b.due_date);
        });
        _all_events.sort(a => {
          return a.status === "Finalizadas";
        });
        setevents(_all_events);
      })
      .then(() => {
        getCommercial(null, null, "?is_class=1", "", true).then(resp => {
          setgroups(
            [
              {
                label: "-- Todas --",
                value: null,
              },
            ].concat(resp.filter(e => e.status === "Ativa")),
          );
        });
      })
      .then(() => {
        setpageloaded(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is recreated on every WrapperProvider render; this should only (re)fetch when `reload` is toggled.
  }, [reload, stringToDate]);

  const filter_init = {
    "Data Inicial": "",
    "Data Final": "",
    Ano: "",
    Período: "",
    Status: "",
  };
  const [filter, setFilter] = useState(filter_init);

  useEffect(() => {
    if (events) {
      let _events_filtered = [...events];

      if (filter["Status"] === "A Acontecer") {
        _events_filtered = _events_filtered.filter(e => e.status === "A Acontecer");
      } else if (filter["Status"] === "A Definir") {
        _events_filtered = _events_filtered.filter(e => e.status === "A Definir");
      } else if (filter["Status"] === "Finalizadas") {
        _events_filtered = _events_filtered.filter(e => e.status === "Finalizadas");
      }
      if (filter["Data Inicial"]) {
        _events_filtered = _events_filtered.filter(
          e => e.due_date && stringToDate(e.due_date) >= stringToDate(filter["Data Inicial"]),
        );
      }
      if (filter["Data Final"]) {
        _events_filtered = _events_filtered.filter(
          e => e.due_date && stringToDate(e.due_date) <= stringToDate(filter["Data Final"]),
        );
      }
      if (filter["Ano"]) {
        _events_filtered = _events_filtered.filter(e => e.commercial.year === filter["Ano"]);
      }
      if (filter["Período"]) {
        _events_filtered = _events_filtered.filter(e => e.commercial.period === filter["Período"]);
      }
      if (filter["Turma"]) {
        _events_filtered = _events_filtered.filter(e => e.commercial.id === filter["Turma"].value);
      }
      setReports(prevReports => ({
        ...prevReports,
        data: [
          { label: "A Acontecer", value: _events_filtered.filter(e => e.status === "A Acontecer").length || 0 },
          { label: "A Definir", value: _events_filtered.filter(e => e.status === "A Definir").length || 0 },
          { label: "Finalizadas", value: _events_filtered.filter(e => e.status === "Finalizadas").length || 0 },
        ],
        table: _events_filtered.map(e => ({
          label: e.name,
          commercial: e.commercial.name,
          status: e.status,
          due_date: e.due_date,
          color: e.status === "A Acontecer" ? 1 : e.status === "A Definir" ? 2 : e.status === "Finalizadas" ? 3 : 4,
          commercial_id: e.commercial.id,
        })),
      }));
    }
  }, [events, filter, stringToDate]);

  const [reports, setReports] = useState({
    data: [],
    table: [],
    title: "Eventos",
    type: "eventos",
  });

  const [modalOpen, setmodalOpen] = useState(null);

  useEffect(() => {
    setbreadcrumb([{ label: "Relatórios" }]);
  }, [setbreadcrumb]);

  return (
    <PrintPage has_logo={true} signed_by={me.username}>
      <Main>
        <ModalAddTask
          reload={reload}
          reloadCalendar={() => {
            setreload(!reload);
          }}
          itemId={modalOpen}
          show={modalOpen}
          onHide={() => setmodalOpen(null)}
        />
        {pageloaded ? (
          <Content>
            <Row>
              <Col>
                <div className="d-flex justify-content-between">
                  <h2 className="page-title">Eventos</h2>
                  <div className="d-flex ml-4">
                    <PrintPage.PrintButton label="Gerar PDF" />
                    <PrintPage.CSVButton
                      label="Gerar CSV"
                      title={reports.title}
                      overview={reports.data}
                      table={reports?.table?.map(_row => ({
                        ...(_row.label !== undefined && { Evento: _row.label }),
                        ...(_row.commercial !== undefined && { Turma: _row.commercial }),
                        ...(_row.status !== undefined && { Status: _row.status }),
                        ...(_row.due_date !== undefined && { Data: formatDate(_row.due_date, 1) }),
                      }))}
                      signed_by={me.username}
                      filter={{
                        ...filter,
                        Turma: filter["Turma"]?.label,
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt-2" style={{ zIndex: 10, position: "relative" }}>
              <Col sm={3}>
                <span className="lince-input_label">Data Inicial</span>
                <DatePicker
                  canClear
                  selected={filter["Data Inicial"]}
                  changeDate={e => {
                    setFilter({
                      ...filter,
                      "Data Inicial": e,
                    });
                  }}
                />
              </Col>
              <Col sm={3}>
                <span className="lince-input_label">Data Final</span>
                <DatePicker
                  canClear
                  selected={filter["Data Final"]}
                  changeDate={e => {
                    setFilter({
                      ...filter,
                      "Data Final": e,
                    });
                  }}
                />
              </Col>
              <Col sm={3}>
                <span className="lince-input_label">Turma</span>
                <Slct
                  className="w-100"
                  options={groups}
                  placeholder="..."
                  value={filter["Turma"]?.value}
                  onChange={e => {
                    setFilter({
                      ...filter,
                      Turma: { value: e.value, label: e.label },
                    });
                  }}
                />
              </Col>
              <Col sm={3}>
                <Row className="ano-periodo">
                  <Col sm={7} className="pr-0">
                    <span className="lince-input_label mb-1">Ano/Período</span>
                    <div className="lince-input__text">
                      <IntegerNumber
                        value={filter["Ano"]}
                        valueChange={ev => {
                          setFilter({
                            ...filter,
                            init: false,
                            Ano: ev || "",
                          });
                        }}
                        maxlength="4"
                      />
                    </div>
                  </Col>
                  <Col className="d-flex align-items-end pl-0">
                    <Slct
                      className="w-100"
                      options={[
                        { value: "", label: "1 e 2" },
                        { value: 1, label: "1" },
                        { value: 2, label: "2" },
                      ]}
                      placeholder="..."
                      value={filter["Período"]}
                      onChange={e => {
                        setFilter({
                          ...filter,
                          init: false,
                          Período: e.value,
                        });
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col sm={3}>
                <span className="d-block">Status</span>
                <Slct
                  className="w-100"
                  options={[
                    { label: "A Acontecer", value: "A Acontecer" },
                    { label: "Finalizadas", value: "Finalizadas" },
                    { label: "A Definir", value: "A Definir" },
                    { label: "-- Todos --", value: "" },
                  ]}
                  placeholder="..."
                  value={filter["Status"]}
                  onChange={e => {
                    setFilter({
                      ...filter,
                      Status: e.value,
                    });
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <button
                  onClick={() => {
                    setFilter(filter_init);
                  }}
                  className={`clear-search ${
                    JSON.stringify(filter) === JSON.stringify(filter_init) ? "disabled" : "mt-3"
                  }`}
                >
                  <span>
                    <span>
                      <IcX />
                    </span>
                    <span>Limpar busca</span>
                  </span>
                </button>
              </Col>
            </Row>
            <Row>
              <Col>
                {reports?.table && (
                  <>
                    <ChartsBar reports={reports.data} title={reports.title} type={reports.type} />
                    <TableResponsive
                      className="mt-4"
                      table={{
                        head: [{ data: "Evento" }, { data: "Turma" }, { data: "Data" }, { data: "" }],
                        body:
                          reports.table.map(__report => ({
                            data: [
                              { element: __report.label },
                              {
                                element: (
                                  <NavLink to={`/groups/${__report.commercial_id}/registrationdata`} target="_blank">
                                    {__report.commercial || "-"}
                                  </NavLink>
                                ),
                              },
                              // { element: __report.commercial },
                              { element: __report.due_date ? formatDate(stringToDate(__report.due_date), 2) : "-" },
                              {
                                element: (
                                  <div style={{ textAlign: "right" }}>
                                    <StatusFlag
                                      style={{ backgroundColor: colorFromIndex(__report.color) }}
                                      status={__report.status}
                                    />
                                  </div>
                                ),
                              },
                            ],
                            border: colorFromIndex(__report.color),
                          })) || [],
                      }}
                    />
                  </>
                )}
              </Col>
            </Row>
          </Content>
        ) : (
          <Content>
            <Loading />
          </Content>
        )}
      </Main>
    </PrintPage>
  );
}
